import { render, staticRenderFns } from "./otchetLgota.vue?vue&type=template&id=755838f7"
import script from "./otchetLgota.vue?vue&type=script&lang=js"
export * from "./otchetLgota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports